'use strict';

var Backbone = require('backbone/backbone');
var _ = require('underscore/underscore');

var IndexSection = require('components/IndexSection/IndexSection');

require('./IndexExperiences.less');


module.exports = IndexSection.extend({

    //is next section on show animation lies under or moves from outside
    NEXT_SECTION_MOVE: true,

    el: '.IndexExperiences',

    stop: false,

    events: _.extend({}, IndexSection.prototype.baseEvents),


    initialize: function (options) {
        _.bindAll(this, 'onResize', 'onResourcesReady');

        this.isVideoApplause = Modernizr.webgl && !Modernizr.ieany && app.settings.isDesktop;

        if (app.settings.isPhone) {
            this.resources = {
                'car_0': app.staticPath + 'img/IndexExperiences/car/10000_mobile.png',
                'car_1': app.staticPath + 'img/IndexExperiences/car/10001_mobile.png',
                'car_2': app.staticPath + 'img/IndexExperiences/car/10002_mobile.png',
                'car_3': app.staticPath + 'img/IndexExperiences/car/10003_mobile.png',
                'car_4': app.staticPath + 'img/IndexExperiences/car/10004_mobile.png',
                'car_5': app.staticPath + 'img/IndexExperiences/car/10005_mobile.png',
                'car_6': app.staticPath + 'img/IndexExperiences/car/10006_mobile.png',
                'car_7': app.staticPath + 'img/IndexExperiences/car/10007_mobile.png',
                'car_8': app.staticPath + 'img/IndexExperiences/car/10008_mobile.png',
                'car_9': app.staticPath + 'img/IndexExperiences/car/10009_mobile.png',
                'car_10': app.staticPath + 'img/IndexExperiences/car/10010_mobile.png',
                'car_11': app.staticPath + 'img/IndexExperiences/car/10011_mobile.png',
                'car_12': app.staticPath + 'img/IndexExperiences/car/10012_mobile.png',
                'car_13': app.staticPath + 'img/IndexExperiences/car/10013_mobile.png',
                'car_14': app.staticPath + 'img/IndexExperiences/car/10014_mobile.png',
                'car_15': app.staticPath + 'img/IndexExperiences/car/10015_mobile.png',
                'car_16': app.staticPath + 'img/IndexExperiences/car/10016_mobile.png',
                'car_17': app.staticPath + 'img/IndexExperiences/car/10017_mobile.png',
                'car_18': app.staticPath + 'img/IndexExperiences/car/10018_mobile.png',
                'car_19': app.staticPath + 'img/IndexExperiences/car/10019_mobile.png',
                'car_20': app.staticPath + 'img/IndexExperiences/car/10020_mobile.png',
                'applause': app.staticPath + 'img/IndexExperiences/applause.png',
            };
        } else {
            this.resources = {
                'car_0': app.staticPath + 'img/IndexExperiences/car/10000.png',
                'car_1': app.staticPath + 'img/IndexExperiences/car/10001.png',
                'car_2': app.staticPath + 'img/IndexExperiences/car/10002.png',
                'car_3': app.staticPath + 'img/IndexExperiences/car/10003.png',
                'car_4': app.staticPath + 'img/IndexExperiences/car/10004.png',
                'car_5': app.staticPath + 'img/IndexExperiences/car/10005.png',
                'car_6': app.staticPath + 'img/IndexExperiences/car/10006.png',
                'car_7': app.staticPath + 'img/IndexExperiences/car/10007.png',
                'car_8': app.staticPath + 'img/IndexExperiences/car/10008.png',
                'car_9': app.staticPath + 'img/IndexExperiences/car/10009.png',
                'car_10': app.staticPath + 'img/IndexExperiences/car/10010.png',
                'car_11': app.staticPath + 'img/IndexExperiences/car/10011.png',
                'car_12': app.staticPath + 'img/IndexExperiences/car/10012.png',
                'car_13': app.staticPath + 'img/IndexExperiences/car/10013.png',
                'car_14': app.staticPath + 'img/IndexExperiences/car/10014.png',
                'car_15': app.staticPath + 'img/IndexExperiences/car/10015.png',
                'car_16': app.staticPath + 'img/IndexExperiences/car/10016.png',
                'car_17': app.staticPath + 'img/IndexExperiences/car/10017.png',
                'car_18': app.staticPath + 'img/IndexExperiences/car/10018.png',
                'car_19': app.staticPath + 'img/IndexExperiences/car/10019.png',
                'car_20': app.staticPath + 'img/IndexExperiences/car/10020.png',
                'applause': app.staticPath + (this.isVideoApplause ? 'img/IndexExperiences/applause.mp4' : 'img/IndexExperiences/applause.png')
            };
        }

        this.on('resources-ready', this.onResourcesReady);

        IndexSection.prototype.initialize.call(this, options);
    },


    onResourcesReady: function() {
        this.paralaxHandler = this.initParalax();
        this.applauseHandler = this.initApplause();

        this.lights = [];


        this.$('.IndexExperiences-car-image').each(function (ind, item) {
            var $image = $(item);
            var id = $image.attr('data-id');
            var src = this.resources['car_' + id];

            if (src) {
                $image.css('background-image', 'url(' + src + ')');
            }
        }.bind(this));


        this.$('.IndexExperiences-light').each(function (ind, item) {
            this.lights.push({
                $item: $(item),
                width: 8
            });
        }.bind(this));
    },


    show: function (params) {
        IndexSection.prototype.show.call(this, params);

        this.onResize();

        this.paralaxHandler.resume();
        this.applauseHandler.resume();

        $(window).on('resize', this.onResize);
    },


    onHideEnd: function(params) {
        this.paralaxHandler.pause();
        this.applauseHandler.pause();

        $(window).off('resize', this.onResize);
    },


    onResize: function () {
        this.carWidth = this.$('.IndexExperiences-car').width();
        this.applauseWidth = this.$('.IndexExperiences-applause').width();
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;

        _.each(this.lights, function (light) {
            light.left = light.$item.offset().left;
        })
    },


    initApplause: function () {

        if (!this.isVideoApplause) {
            this.$('.IndexExperiences-applause').css('background-image', 'url(' + this.resources['applause'] + ')');

            return {
                resume: function () {},
                pause: function () {}
            };
        }

        var self = this;
        var videoW = 1280;
        var videoH = 454;
        var animationFrame;

        var opacityShader = [
            'precision mediump float;',
            'varying vec2 vTextureCoord;',
            'uniform sampler2D uSampler;',
            'void main(){',
            'vec4 c=texture2D(uSampler, vTextureCoord);',
            'float a = 1.0 - c.r;',
            'gl_FragColor=vec4(0, 0, 0, a);',
            '}'
        ].join('\n');


        var renderer = new PIXI.autoDetectRenderer(videoW, videoH, {transparent: true});
        this.$('.IndexExperiences-applause').append(renderer.view);

        var stage = new PIXI.Container();

        var $video = $('<video muted playsinline crossorigin loop preload="auto"></video>');
        $video.attr('src', this.resources['applause']);

        var videoTexture = PIXI.Texture.fromVideo($video[0]);
        var videoSprite = new PIXI.Sprite(videoTexture);
        stage.addChild(videoSprite);

        videoTexture.baseTexture.autoPlay = false;

        //create shader
        var shader = new PIXI.Filter(null, opacityShader);

        //apply shader
        stage.filters = [shader];

        function animate() {

            animationFrame = requestAnimationFrame(animate);

            renderer.render(stage);
        }

        return {
            resume: function () {
                if (videoTexture.baseTexture.hasLoaded) {
                    $video[0].play();
                } else {
                    videoTexture.baseTexture.on('loaded', function() {
                        $video[0].play();
                    });
                }

                cancelAnimationFrame(animationFrame);

                animate();
            },

            pause: function () {
                videoTexture.baseTexture.off('loaded');

                $video[0].pause();

                cancelAnimationFrame(animationFrame);
           }
        };

    },


    initParalax: function () {

        var animationFrameId, inertion, stopTimeout,
            dxTarget = 0,
            prevX,
            dx = 0,
            dyTarget = 0,
            dy = 0,
            inertion = 0,
            tracking = false,
            self = this,
            imgsCount = this.$('.IndexExperiences-car-image').length,
            index, prevIndex;


        return {
            resume: function () {
                if (app.settings.isDesktop) {
                    $('body').on('mouseenter', startTracking);
                    $('body').on('mouseleave', stopTracking);
                    $('body').on('mousemove', mousePosChanged);
                } else {
                    window.addEventListener('deviceorientation', orientationChanged, false);
                    startTracking();
                }
            },

            pause: function () {
                stopTracking();

                if (app.settings.isDesktop) {
                    $('body').off('mouseenter', startTracking);
                    $('body').off('mouseleave', stopTracking);
                    $('body').off('mousemove', mousePosChanged);
                } else {
                    window.removeEventListener('deviceorientation', orientationChanged, false);
                }
            }
        };


        function startTracking() {
            tracking = true;

            clearTimeout(stopTimeout);
            window.cancelAnimationFrame(animationFrameId);

            self.$('.IndexExperiences-car-image').css('opacity', '');
            prevIndex = undefined;

            inertion = 0;
            applyParalax();

            function applyParalax() {

                dx += (dxTarget - dx) * inertion;
                dy += (dyTarget - dy) * inertion;

                inertion = Math.min(inertion + 0.05, 0.2);

                index = imgsCount - Math.floor(((dx + 1) / 2) * imgsCount) - 1;
                if (index != prevIndex) {
                    self.$('.IndexExperiences-car-image--' + index).css('opacity', '1');
                    (prevIndex != undefined) && self.$('.IndexExperiences-car-image--' + prevIndex).css('opacity', '');
                }
                prevIndex = index;

                var xCarShift = dx * (self.windowWidth * 0.01) / 2;
                var xApplauseShift = dx * (self.applauseWidth - self.windowWidth - 4) / 2;

                var yCarShift = dy * (self.windowWidth * 0.01) / 4;
                var yApplauseShift = dy * (self.applauseWidth - self.windowWidth - 4) / 8;

                self.$('.IndexExperiences-car-container').css({
                    'transform': 'translateX(' + -Math.round(xCarShift * 10) / 10 + 'px)'
                });

                self.$('.IndexExperiences-car').css({
                    'transform': 'translateY(' + -Math.round(yCarShift * 10) / 10 + 'px)'
                });

                self.$('.IndexExperiences-applause').css({
                    'transform': 'translate(' + -Math.round(xApplauseShift * 10) / 10 + 'px, ' + -Math.round(yApplauseShift * 10) / 10 + 'px)'
                });

                animationFrameId = window.requestAnimationFrame(applyParalax);
            }
        };


        function stopTracking() {
            // dxTarget = 0;
            // inertion = 0;

            // tracking = false;

            // stopTimeout = setTimeout(function(){
            //     window.cancelAnimationFrame(animationFrameId);
            // }, 1000);

            inertion = 0;
            tracking = false;
            prevIndex = undefined;
            window.cancelAnimationFrame(animationFrameId);
        };


        //check if mouse intersects some vertical lights
        function flashLights(x1, x2) {
            var xMin = Math.min(x1, x2);
            var xMax = Math.max(x1, x2);

            _.each(self.lights, function (light, ind) {
                var st = light.left - light.width;
                var ed = light.left + light.width;

                if (!(ed < xMin || st > xMax)) {
                    clearTimeout(light.resetShowTimeout);

                    light.$item.addClass('IndexExperiences-light--visible');

                    light.resetShowTimeout = setTimeout(function () {
                        light.$item.removeClass('IndexExperiences-light--visible');
                    }, 200);
                }
            })
        }


        function orientationChanged(e) {
            switch (window.orientation) {
                case 0:
                    dyTarget = -(.02 * e.beta - .25 * Math.PI);
                    dxTarget = .03 * -e.gamma;
                    break;
                case 90:
                    dyTarget = -(.02 * -e.gamma - .25 * Math.PI);
                    dxTarget = .04 * -e.beta;
                    break;
                case -90:
                    dyTarget = -(.02 * e.gamma - .25 * Math.PI);
                    dxTarget = .04 * e.beta;
            }

            dyTarget > .5 ? dyTarget = .5 : dyTarget < -.5 && (dyTarget = -.5);
            dxTarget > .5 ? dxTarget = .5 : dxTarget < -.5 && (dxTarget = -.5);
            dy = dyTarget;
            dx = dxTarget;
        }


        function mousePosChanged(e) {
            dxTarget = e.pageX / (self.windowWidth / 2) - 1;
            dyTarget = e.pageY / (self.windowHeight / 2) - 1;

            prevX !== undefined && flashLights(prevX, e.pageX);

            prevX = e.pageX;

            if (!tracking) {
                startTracking();
            }
        }
    },


});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/app/components/IndexExperiences/IndexExperiences.js
 ** module id = 14
 ** module chunks = 0
 **/